import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractPredictionRuleModel from "./AbstractPredictionRuleModel.js";

/**
 * Compute data from a given initial value, with a growth percentage
 * on each predicted period. So, if the `initialValue` is 100 and
 * `growthPercentage` is 10, the first predicted month will have value
 * "100", the next one value "110"…
 *
 * @param {float} initialValue - The value for the first predicted month
 * @param {float} growthPercentage - The increase/decrease to compute a
 * month based on the value of the previous one
 */
export default class ConstantPredictionRuleModel extends AbstractPredictionRuleModel {
	constructor({ initialValue = 0, growthPercentage = 0 } = {}) {
		super(...arguments);

		this._initialValue = initialValue;
		this._growthPercentage = growthPercentage;
	}

	getInitialValue() {
		return this._initialValue;
	}

	setInitialValue(initialValue) {
		this._initialValue = initialValue;
	}

	getGrowthPercentage() {
		return this._growthPercentage;
	}

	setGrowthPercentage(growthPercentage) {
		this._growthPercentage = growthPercentage;
	}

	accept(visitor) {
		return visitor.visitConstantPredictionRuleModel(this);
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.initialValue = this._initialValue;
		properties.growthPercentage = this._growthPercentage;

		return properties;
	}

	static getType() {
		return "Constant";
	}

	static getLabel() {
		return _("Constant");
	}

	static getDescriptionText() {
		return _("Forecast based on an initial value and a growth");
	}
}
